<template>
  <div class="explore">
    <div class="loader" v-if="!dataLoaded">loading ...</div>
    <div class="explore-page" v-if="dataLoaded">
      <leaflet-map :currentScreenId="null" :hidden="false" :isExplore="true" :locale="$i18n.locale" />
      <img  @click="openMenu" class="menu-icon" src="@/assets/images/menu.svg"/>
      <noah-menu v-if="menuOpened"/>
      <div class="controls">
        <switch-lang/>
        <autoplay/>
      </div>

      <transition name="slide-fade">
        <modal v-if="modalOpened" @close="closeModal()"/>
      </transition>

    </div>
  </div>

</template>

<script>
import Map from '@/components/Map'
import Modal from '@/components/Modal'
import Autoplay from '@/components/Autoplay'
import SwitchLang from '@/components/SwitchLang'
import Menu from '@/components/Menu'

export default {
  name: 'story',
  computed: {
    currentUrl () {
      return window.location.hash
    },
    dataLoaded () {
      return this.$store.state.storyDataLoaded &&
        this.$store.state.campSitesDataLoaded &&
        this.$store.state.mapDataLoaded
    },
    modalOpened () {
      return this.$store.state.modal.opened
    },
    menuOpened () {
      return this.$store.state.menuOpened
    },
    lang () {
      return this.$store.state.lang
    }
  },
  components: {
    LeafletMap: Map,
    Modal,
    NoahMenu: Menu,
    Autoplay,
    SwitchLang
  },
  mounted () {
    this.$store.dispatch('loadMediaData')
    this.$store.dispatch('loadMapData')
  },
  methods: {
    closeModal () {
      this.$store.dispatch('unselectGeometry')
    },
    openMenu () {
      this.$store.commit('setMenuOpened', true)
    }
  }
}
</script>

<style lang="scss">
#map {
  pointer-events:auto;
  position:absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}
.loader {
  z-index: 2;
}
.explore-page {
   display: flex;
  z-index: 2;
  align-items: center;
  height: 100vh;
  .controls {
    position: absolute;
    display: flex;
    flex-direction: row;
    margin: 64px;
    bottom: 0;
    right: 0;
    background: radial-gradient(ellipse at center, rgba(255,255,255,1) 0%,rgba(255,255,255,0) 100%);
    @media only screen and (max-width: 768px) {
      display: none;
    }
  }
}
.slide-fade-enter-active {
  transition: all .5s ease;
}
.slide-fade-leave-active {
  transition: all .5s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(-720px);
  opacity: 0;
}
.menu-icon {
  // position: absolute;
  width: 24px;
  height: 24px;
  object-fit: contain;
  top: 48px;
  left: 120px;
  @media only screen and (max-width: 768px) {
    left: auto;
    right: 24px;
    top: 24px;
  }
  cursor: pointer;
  pointer-events: auto;
}

</style>
